import React from 'react';
import PropTypes from 'prop-types';

const V3MobileOfferBreadcrumb = ({ onBack, onOpenSheet }) => (
  <div className="v3-mobile-breadcrumb">
    <button
      type="button"
      data-testid="v3-mobile-offer-header-back"
      className="v3-mobile-breadcrumb__back"
      onClick={onBack}
    >
      <i className="far fa-chevron-left" aria-hidden="true" />
      <span>Offers</span>
    </button>
    <button
      type="button"
      data-testid="v3-mobile-offer-header-actions"
      className="v3-mobile-breadcrumb__actions"
      aria-haspopup="menu"
      onClick={onOpenSheet}
    >
      Actions
      <i className="far fa-chevron-down" aria-hidden="true" />
    </button>
  </div>
);

V3MobileOfferBreadcrumb.propTypes = {
  onBack: PropTypes.func.isRequired,
  onOpenSheet: PropTypes.func.isRequired,
};

export default V3MobileOfferBreadcrumb;
